import { useContext } from 'react';
import ClientContext from './ClientContext';
import GraphQLClient from './GraphQLClient';
import LocalGraphQLClient from './LocalGraphQLClient';
import LocalGraphQLError from './LocalGraphQLError';
import { requestClientExecute } from './request';
import { useQueryApplication, useQueryServicing } from './useQuery';
import {
  useSubscriptionApplication
} from './useSubscription';
import useClientRequest from './useClientRequest';


const applicationUseMutation = (query: any, options: any = {}) => {
  // @ts-ignore
  const { applicationClient } = useContext(ClientContext);

  return requestClientExecute(query, applicationClient, options)
};

const applicationUseManualQuery = (query: any, options: any) => {
  // @ts-ignore
  const { applicationClient } = useContext(ClientContext);

  return requestClientExecute(query, applicationClient, options)
};

const servicingUseMutation = (query: any, options: any) => {
  // @ts-ignore
  const { servicingClient } = useContext(ClientContext);

  return requestClientExecute(query, servicingClient, options);
};

export {
  ClientContext,
  GraphQLClient,
  LocalGraphQLClient,
  LocalGraphQLError,
  useClientRequest,
  useQueryServicing,
  useQueryApplication,
  useSubscriptionApplication,
  applicationUseMutation,
  applicationUseManualQuery,
  // alias
  servicingUseMutation
};
